var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"app":"","clipped":""}},_vm._l((_vm.page_groups),function(group){return _c('v-list',{key:group.title},[_c('v-subheader',[_vm._v(_vm._s(group.title))]),_c('v-list-item-group',{attrs:{"color":"primary"}},_vm._l((group.items),function(ref,i){
var icon = ref[0];
var text = ref[1];
var to = ref[2];
return _c('v-list-item',{key:i,attrs:{"to":to,"link":""}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(text))])],1)],1)}),1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }